/**
 * Verwijdert diakritische tekens (accenten) uit een string, zodat "Visé" en "Vise" gelijk zijn.
 */
export function removeDiacritics(input: string): string {
    if (!input) return "";
    return input.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

export function normalizeForSearch(input: string): string {
    if (!input) return "";
    return removeDiacritics(input).trim().toLowerCase();
}

export function stringToEnumKey<T>(string: string): keyof T {
    return string
        .replace(/([A-Z])/g, "_$1")
        .slice(1)
        .toUpperCase() as keyof T;
}

export function capitalize(input: string): string {
    if (!input) return "";
    return input.charAt(0).toUpperCase() + input.slice(1);
}

export function decapitalize(input: string): string {
    if (!input) return "";
    return input.charAt(0).toLowerCase() + input.slice(1);
}

export function capitalizeFirstChar(input: string): string {
    if (!input) return "";
    return input.charAt(0).toUpperCase() + input.toLowerCase().slice(1);
}

export function convertToKebabCase(s: string) {
    if (!s) return "";
    return s
        .replaceAll(" ", "-") // just replace all spaces with `-`
        .replaceAll(/([a-z])([A-Z])/g, "$1-$2") // replace CamelCase to Camel-Case
        .toLowerCase(); // make everything lowercase
}

export function convertToSnakeCase(s: string) {
    if (!s) return "";
    return s
        .replaceAll(" ", "_") // replace all spaces with `_`
        .replaceAll(/([a-z])([A-Z])/g, "$1_$2") // replace CamelCase to Camel_Case
        .toLowerCase(); // make everything lowercase
}

/**
 * Joins an array of strings with commas, but uses " en " before the last item.
 * Examples:
 *   ["a"] => "a"
 *   ["a", "b"] => "a en b"
 *   ["a", "b", "c"] => "a, b en c"
 *
 * @param items - The array of strings to join.
 * @returns The joined string with proper Dutch conjunctions.
 */
export function joinWithCommasAndEn(items: string[]): string {
    if (items.length === 0) return "";
    if (items.length === 1) return items[0];
    if (items.length === 2) return `${items[0]} en ${items[1]}`;
    return `${items.slice(0, -1).join(", ")} en ${items[items.length - 1]}`;
}
